import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/crm/expense/budget";

/**
 * 费用预算页接口
 * 职员下拉、部门树走 commonApi
 */
export default {
    /** 查询预算列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询预算详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存预算 */
    saveBudget: (data) => axios.post({url: `${PREFIX_URI}/saveBudget`, data}),
    /** 删除预算 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 费用预算页：KPI + 部门费用列表 + 人员费用列表 */
    page: (data) => axios.get({url: `${PREFIX_URI}/page`, data}),
}
